import React from "react"
import {getMonthName} from "../../components-features/dashboard/insight/months"

export interface FormattedDateProps {
  dateValue: string
}

export const FormattedDate : React.FC<FormattedDateProps> = ({dateValue}) => {
  const date = new Date(dateValue)
  return <>{date.getDate()} {getMonthName(date)} {date.getFullYear()}</>
}